import { FC, useState, Dispatch, SetStateAction } from 'react';

import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';
import { PdpSharedConditionModalLoader } from '../PdpSharedModals/PdpSharedConditionModal/PdpSharedConditionModalLoader';
import * as tracking from 'dibs-tracking';

const openConditionModal = (setModalOpen: Dispatch<SetStateAction<boolean>>): void => {
    tracking.trackEvent({
        category: 'product',
        action: 'view condition descriptions clicked',
    });

    setModalOpen(true);
};

type Props = Exclude<PdpSharedDetailProps, 'selectedSkuId'> & {
    itemId: string;
};

export const PdpSharedDetailCondition: FC<Props> = ({
    detailValues,
    currency,
    delimiter,
    itemId,
}) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                onClickMap={{
                    condition: {
                        clickFn: () => openConditionModal(setModalOpen),
                        dataTn: 'open-condition-modal',
                    },
                }}
                currency={currency}
                delimiter={delimiter}
            />
            <div>
                {/* why were there nest divs? */}
                {/* <div> */}
                <PdpSharedConditionModalLoader
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    itemId={itemId}
                />
                {/* </div> */}
            </div>
        </>
    );
};
